<template>
  <div class="login-page -mb-14" dir="rtl">
    <div class="login-layout">
      <div class="form-panel" ref="form">
        <div class="login-card-outer">
          <div class="logo-wrap">
            <img src="../../../public/img/logo.webp" class="logo" alt="ZoodKomak" />
          </div>

          <div class="form-grid">
            <!-- Mobile Number Input (Level 1) -->
            <div v-if="level == 1">
              <div class="input-group" :data-label="$t('mobileNo')">
                <img class="input-icon" src="/img/smartphone.svg" alt="mobile" />
                <input
                  ref="mobile"
                  class="input"
                  v-model="mobile"
                  style="padding-left: 25px;"
                  placeholder="09123456789"
                  required
                  type="tel"
                  dir="ltr"
                  inputmode="numeric"
                  pattern="[0-9]*"
                  :maxlength="11"
                  @input="sanitizeMobile"
                  @keydown.enter="checkMobileAndSendCode"
                />
              </div>
            </div>

            <!-- SMS Code Input (Level 2) - 5 separate inputs -->
            <div v-if="level == 2" class="code-step-wrapper">
              <button @click="goBackToMobile" class="back-button-circle">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M15 18l-6-6 6-6"/>
                </svg>
              </button>
              <div class="code-input-section">
                <div class="code-label">
                  {{ $t('sendedCode') }}
                  <span class="mobile-number-display">{{ formattedMobileForDisplay }}</span>
                </div>
                <div class="code-inputs">
                  <input
                    v-for="(digit, index) in codeDigits"
                    :key="index"
                    :ref="`codeInput${index}`"
                    class="code-input"
                    v-model="codeDigits[index]"
                    type="tel"
                    inputmode="numeric"
                    pattern="[0-9]*"
                    maxlength="1"
                    @input="handleCodeInput(index, $event)"
                    @keydown="handleCodeKeydown(index, $event)"
                    @keydown.enter="verifyCodeAndLogin"
                    @paste="handleCodePaste($event)"
                    :tabindex="4 - index"
                  />
                </div>
                <div class="resend-section">
                  <button
                    v-if="canResend"
                    @click="resendCode"
                    class="resend-btn"
                    :disabled="resending"
                  >
                    ارسال مجدد کد
                  </button>
                  <span v-else class="resend-timer">
                    ارسال مجدد کد تا {{ formatTime(remainingTime) }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="actions">
            <button v-if="level == 1" class="btn primary" v-on:click="checkMobileAndSendCode()" :disabled="!canProceedMobile">
              {{ $t('login') }}
            </button>
            <button v-if="level == 2" class="btn primary" v-on:click="verifyCodeAndLogin()" :disabled="!canProceedCode">
              {{ $t('login') }}
            </button>
          </div>
        </div>
      </div>

      <div class="visual-panel">
        <div v-if="sliderImages.length" class="slides">
          <div
            v-for="(img, i) in sliderImages"
            :key="i"
            class="slide"
            :class="{ active: currentSlide === i }"
            :style="{ backgroundImage: 'url(' + img + ')' }"
          ></div>
        </div>
        <div v-else class="slide placeholder"></div>
      </div>
    </div>
  </div>
</template>
<script>
  /* eslint-disable */
  import {bus} from '../../main.js'

  export default {
    data() {
      return {
        errors: [],
        mobile: '',
        submittedMobile: '', // Store the mobile number that code was sent to
        level: 1, // 1: mobile input, 2: code input
        codeDigits: ['', '', '', '', ''],
        remainingTime: 180, // 3 minutes in seconds
        timer: null,
        canResend: false,
        resending: false,
        currentSlide: 0,
        slideTimer: null,
        clipboardCheckInterval: null,
        sliderImages: [
          '/img/slider/slider1.webp',
          '/img/slider/slider2.webp',
          '/img/slider/slider3.webp'
        ],
      }
    },
    computed: {
      canProceedMobile() {
        const editedMobile = this.persian_to_english(this.mobile)
        return editedMobile && editedMobile.length >= 10
      },
      canProceedCode() {
        return this.codeDigits.every(digit => digit !== '' && digit.length === 1)
      },
      fullCode() {
        // Reverse the array since input goes from index 4 (left) to 0 (right)
        // but we need to send from left to right (4 to 0) as a string
        return [...this.codeDigits].reverse().join('')
      },
      formattedMobileForDisplay() {
        if (!this.submittedMobile) return ''
        return `${this.submittedMobile}`
      }
    },
    watch: {
      level(newLevel) {
        if (newLevel === 2) {
          // وقتی به صفحه کد تایید رفتیم، clipboard listener رو فعال کن
          this.$nextTick(() => {
            this.setupClipboardListener()
            // شروع چک کردن clipboard هر 2 ثانیه
            if (this.clipboardCheckInterval) {
              clearInterval(this.clipboardCheckInterval)
            }
            this.clipboardCheckInterval = setInterval(() => {
              this.checkClipboardForCode()
            }, 2000)
          })
        } else {
          // وقتی از صفحه کد تایید خارج شدیم، listener رو غیرفعال کن
          if (this.clipboardCheckInterval) {
            clearInterval(this.clipboardCheckInterval)
            this.clipboardCheckInterval = null
          }
          document.removeEventListener('paste', this.handlePasteEvent)
        }
      }
    },
    mounted() {
      // Start slideshow timer
      if (this.sliderImages && this.sliderImages.length > 1) {
        this.slideTimer = setInterval(() => {
          this.currentSlide = (this.currentSlide + 1) % this.sliderImages.length
        }, 5000)
      }
      
      // اگر در صفحه کد تایید هستیم، clipboard listener رو فعال کن
      if (this.level === 2) {
        this.$nextTick(() => {
          this.setupClipboardListener()
          this.clipboardCheckInterval = setInterval(() => {
            this.checkClipboardForCode()
          }, 2000)
        })
      }
    },
    beforeDestroy() {
      if (this.slideTimer) {
        clearInterval(this.slideTimer)
        this.slideTimer = null
      }
      if (this.clipboardCheckInterval) {
        clearInterval(this.clipboardCheckInterval)
        this.clipboardCheckInterval = null
      }
      // حذف paste listener
      document.removeEventListener('paste', this.handlePasteEvent)
      this.clearTimer()
    },
    methods: {
      sanitizeMobile() {
        const persianDigits = ['۰','۱','۲','۳','۴','۵','۶','۷','۸','۹']
        const englishDigits = ['0','1','2','3','4','5','6','7','8','9']
        let value = String(this.mobile || '')
        for (let i = 0; i < persianDigits.length; i++) {
          const re = new RegExp(persianDigits[i], 'g')
          value = value.replace(re, englishDigits[i])
        }
        value = value.replace(/[^0-9]/g, '')
        this.mobile = value.slice(0, 11)
      },
      
      checkMobileAndSendCode() {
        if (!this.canProceedMobile) {
          bus.$emit('show_toast', [2000, 'لطفاً شماره موبایل را وارد کنید'])
          return
        }

        var self = this
        var edited_mobile = this.persian_to_english(this.mobile)
        
        if(!edited_mobile.startsWith('0') && edited_mobile.length == 10){
          edited_mobile = "0" + edited_mobile
        }

        // Step 1: Check if user exists
        const check_data = {
          Phone: edited_mobile
        }

        this.axios.post('/CheckExistsMobileNo', check_data, {})
          .then(response => {
            if (response.data.error == 0) {
              // User exists, now send SMS code
              const mobileForCode = edited_mobile.substring(1)
              const mobileNo = "0" + mobileForCode
              
              const code_data = {
                MobileNo: mobileNo
              }

              this.axios.post('/GenerateNewCode', code_data, {})
                .then(codeResponse => {
                  if (codeResponse.data.error == 0) {
                    // Store the submitted mobile number for display
                    self.submittedMobile = edited_mobile
                    bus.$emit('show_toast', [2000, codeResponse.data.msg || 'کد تایید ارسال شد', 'success'])
                    self.level = 2
                    self.startTimer()
                    // Focus last code input (leftmost in RTL, index 4)
                    self.$nextTick(() => {
                      const lastInput = self.$refs.codeInput4
                      if (lastInput) {
                        const input = Array.isArray(lastInput) ? lastInput[0] : lastInput
                        if (input && input.focus) input.focus()
                      }
                    })
                  } else {
                    bus.$emit('show_toast', [2000, codeResponse.data.msg || 'خطا در ارسال کد'])
                  }
                })
                .catch(e => {
                  console.error('Error generating code:', e)
                  bus.$emit('show_toast', [2000, 'خطا در ارسال کد تایید'])
                })
            } else {
              bus.$emit('show_toast', [2000, response.data.msg || 'شماره موبایل در سیستم ثبت نشده است'])
            }
          })
          .catch(e => {
            console.error('Error checking mobile:', e)
            bus.$emit('show_toast', [2000, 'خطا در بررسی شماره موبایل'])
          })
      },

      handleCodeInput(index, event) {
        let value = event.target.value.replace(/[^0-9]/g, '')
        
        // Convert Persian to English
        const persianDigits = ['۰','۱','۲','۳','۴','۵','۶','۷','۸','۹']
        const englishDigits = ['0','1','2','3','4','5','6','7','8','9']
        for (let i = 0; i < persianDigits.length; i++) {
          value = value.replace(new RegExp(persianDigits[i], 'g'), englishDigits[i])
        }
        
        if (value.length > 1) {
          // If paste or multiple digits, distribute them from left to right (index 4 to 0)
          const digits = value.split('').slice(0, 5)
          // Start from index 4 (leftmost) and go to right
          const startIndex = 4
          digits.forEach((digit, i) => {
            const targetIndex = startIndex - i
            if (targetIndex >= 0 && targetIndex < 5) {
              this.codeDigits[targetIndex] = digit
            }
          })
          // Focus rightmost filled input (lowest index)
          const rightmostIndex = Math.max(startIndex - (digits.length - 1), 0)
          this.$nextTick(() => {
            if (this.$refs[`codeInput${rightmostIndex}`] && this.$refs[`codeInput${rightmostIndex}`][0]) {
              this.$refs[`codeInput${rightmostIndex}`][0].focus()
            }
            
            // اگر همه 5 رقم paste شد، به صورت خودکار ورود کن
            if (digits.length === 5 && this.canProceedCode) {
              setTimeout(() => {
                this.verifyCodeAndLogin()
              }, 300)
            }
          })
        } else {
          this.codeDigits[index] = value
          // Auto focus next input (going from left to right, so index decreases: 4 -> 3 -> 2 -> 1 -> 0)
          if (value && index > 0) {
            this.$nextTick(() => {
              if (this.$refs[`codeInput${index - 1}`] && this.$refs[`codeInput${index - 1}`][0]) {
                this.$refs[`codeInput${index - 1}`][0].focus()
              }
            })
          }
          
          // اگر آخرین رقم (index 0) وارد شد و همه رقم‌ها پر شدن، به صورت خودکار ورود کن
          if (value && index === 0) {
            this.$nextTick(() => {
              // چک کن که آیا همه 5 رقم پر شده
              if (this.canProceedCode) {
                // کمی تاخیر برای UX بهتر
                setTimeout(() => {
                  this.verifyCodeAndLogin()
                }, 300)
              }
            })
          }
        }
      },

      handleCodeKeydown(index, event) {
        // Handle backspace - going from right to left when deleting (index increases: 0 -> 1 -> 2 -> 3 -> 4)
        if (event.key === 'Backspace' && !this.codeDigits[index] && index < 4) {
          this.$nextTick(() => {
            if (this.$refs[`codeInput${index + 1}`] && this.$refs[`codeInput${index + 1}`][0]) {
              this.$refs[`codeInput${index + 1}`][0].focus()
            }
          })
        }
      },

      handleCodePaste(event) {
        event.preventDefault()
        const pastedData = event.clipboardData.getData('text')
        const digits = pastedData.replace(/[^0-9]/g, '').split('').slice(0, 5)
        
        // Fill from left to right (index 4 to 0)
        digits.forEach((digit, i) => {
          const targetIndex = 4 - i
          if (targetIndex >= 0 && targetIndex < 5) {
            this.codeDigits[targetIndex] = digit
          }
        })
        
        // Focus rightmost filled input (lowest index)
        const rightmostIndex = Math.max(4 - (digits.length - 1), 0)
        this.$nextTick(() => {
          if (this.$refs[`codeInput${rightmostIndex}`] && this.$refs[`codeInput${rightmostIndex}`][0]) {
            this.$refs[`codeInput${rightmostIndex}`][0].focus()
          }
          
          // اگر همه 5 رقم paste شد، به صورت خودکار ورود کن
          if (digits.length === 5 && this.canProceedCode) {
            setTimeout(() => {
              this.verifyCodeAndLogin()
            }, 300)
          }
        })
      },

      saveImageUrlFromToken(mobileNo, password) {
        const send_data = {
          MobileNo: String(mobileNo || '').replace('+98', ''),
          Pass: password,
        }
        this.axios.post('https://panel.zoodkomak.com/jetToken/GetToken', send_data, { show_pros: false })
          .then(response => {
            if (response.data && response.data.ImageUrl) {
              localStorage.setItem('ImageUrl', response.data.ImageUrl)
            }
            if (response.data && response.data.UserId) {
              localStorage.setItem('userId2', response.data.UserId)
            }
          })
          .catch(() => {})
      },

      verifyCodeAndLogin() {
        if (!this.canProceedCode) {
          bus.$emit('show_toast', [2000, 'لطفاً کد 5 رقمی را کامل وارد کنید'])
          return
        }

        var self = this
        var edited_mobile = this.persian_to_english(this.mobile)
        
        if(!edited_mobile.startsWith('0') && edited_mobile.length == 10){
          edited_mobile = "0" + edited_mobile
        }
        
        edited_mobile = edited_mobile.substring(1)
        edited_mobile = "0" + edited_mobile

        // Call NewActivate with OTP as Password
        const send_data = {
          Phone: this.persian_to_english(edited_mobile),
          Password: this.fullCode, // OTP code is passed as Password
          AppNo: "4",
          Name: "PWA",
          DeviceModel: "android",
          OsName: "PWA",
          OsVersion: "1"
        }

        this.axios.post('/NewActivate', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              console.log("NewActivate response", response)

              // Store user data if provided
              if (response.data.profile) {
                localStorage.setItem("profile", JSON.stringify(response.data.profile))
                bus.$emit('signalr_user_ready')
              }
              
              // Get password from NewActivate response (response.data.pass)
              const passwordFromActivate = response.data.pass || self.fullCode
              const mobileNoForLogin = self.persian_to_english(edited_mobile)
              
              localStorage.setItem("phone", mobileNoForLogin)
              localStorage.setItem("password", passwordFromActivate)
              if (response.data.newVersion && response.data.newVersion.PrivateCall) {
                localStorage.setItem("PrivateCall", response.data.newVersion.PrivateCall)
              }

              self.saveImageUrlFromToken(mobileNoForLogin, passwordFromActivate)

              // Call TechnicianLogin with Password from NewActivate (pass)
              const technicianLoginData = {
                MobileNo: mobileNoForLogin,
                Password: passwordFromActivate, // Use pass from NewActivate response
                OsName: "PWA",
                AppNo: "4",
                OsVersion: "1",
                DeviceModel: "android"
              }

              self.axios.post('/TechnicianLogin', technicianLoginData, {})
                .then(techResponse => {
                  console.log("TechnicianLogin response", techResponse)
                  
                  // Store profile and other data from TechnicianLogin
                  if (techResponse.data.error == 0) {
                    if (techResponse.data.profile) {
                      localStorage.setItem("profile", JSON.stringify(techResponse.data.profile))
                      bus.$emit('signalr_user_ready')
                    }
                    if (techResponse.data.newVersion && techResponse.data.newVersion.PrivateCall) {
                      localStorage.setItem("PrivateCall", techResponse.data.newVersion.PrivateCall)
                    }
                  }

                  // Call check_user_in_zoodkomak with data from NewActivate response
                  const userId = response.data.UserId || (response.data.profile && response.data.profile.UserId) || (techResponse.data.profile && techResponse.data.profile.UserId)
                  const mobileNo = mobileNoForLogin
                  const password = passwordFromActivate

                  if (userId && mobileNo && password) {
                    var formData = new FormData()
                    formData.append('UserId', userId)
                    formData.append('MobileNo', mobileNo)
                    formData.append('Password', password)

                    self.axios.post('https://cp.zoodkomak.com/api/check_user_in_zoodkomak', formData, {show_pros: false})
                      .then(checkResponse => {
                        console.log('check_user_in_zoodkomak response:', checkResponse)
                        // Navigate after successful check
                        self.$router.push({path: "/post-login", params: {}})
                        bus.$emit('show_toast', [2000, response.data.msg || 'ورود موفقیت‌آمیز', 'success'])
                      })
                      .catch(checkError => {
                        console.error('Error in check_user_in_zoodkomak:', checkError)
                        // Navigate even if check fails
                        self.$router.push({path: "/post-login", params: {}})
                        bus.$emit('show_toast', [2000, response.data.msg || 'ورود موفقیت‌آمیز', 'success'])
                      })
                  } else {
                    // If required data is missing, still navigate
                    console.warn('Missing data for check_user_in_zoodkomak:', { userId, mobileNo, password: password ? '***' : null })
                    self.$router.push({path: "/post-login", params: {}})
                    bus.$emit('show_toast', [2000, response.data.msg || 'ورود موفقیت‌آمیز', 'success'])
                  }
                })
                .catch(techError => {
                  console.error('Error in TechnicianLogin:', techError)
                  // Still proceed with check_user_in_zoodkomak even if TechnicianLogin fails
                  const userId = response.data.UserId || (response.data.profile && response.data.profile.UserId)
                  const mobileNo = mobileNoForLogin
                  const password = passwordFromActivate

                  if (userId && mobileNo && password) {
                    var formData = new FormData()
                    formData.append('UserId', userId)
                    formData.append('MobileNo', mobileNo)
                    formData.append('Password', password)

                    self.axios.post('https://cp.zoodkomak.com/api/check_user_in_zoodkomak', formData, {show_pros: false})
                      .then(checkResponse => {
                        console.log('check_user_in_zoodkomak response:', checkResponse)
                        self.$router.push({path: "/post-login", params: {}})
                        bus.$emit('show_toast', [2000, response.data.msg || 'ورود موفقیت‌آمیز', 'success'])
                      })
                      .catch(checkError => {
                        console.error('Error in check_user_in_zoodkomak:', checkError)
                        self.$router.push({path: "/post-login", params: {}})
                        bus.$emit('show_toast', [2000, response.data.msg || 'ورود موفقیت‌آمیز', 'success'])
                      })
                  } else {
                    self.$router.push({path: "/post-login", params: {}})
                    bus.$emit('show_toast', [2000, response.data.msg || 'ورود موفقیت‌آمیز', 'success'])
                  }
                })

            } else {
              bus.$emit('show_toast', [2000, response.data.msg || 'خطا در فعال‌سازی'])
              // Clear code on error
              this.codeDigits = ['', '', '', '', '']
              this.$nextTick(() => {
                // Focus leftmost input (index 4) on error
                const lastInput = this.$refs.codeInput4
                if (lastInput) {
                  const input = Array.isArray(lastInput) ? lastInput[0] : lastInput
                  if (input && input.focus) input.focus()
                }
              })
            }
          })
          .catch(e => {
            self.errors.push(e)
            bus.$emit('show_toast', [2000, 'خطا در ارتباط با سرور'])
          })
      },

      startTimer() {
        this.canResend = false
        this.remainingTime = 180 // 3 minutes
        
        this.clearTimer()
        
        this.timer = setInterval(() => {
          this.remainingTime--
          if (this.remainingTime <= 0) {
            this.canResend = true
            this.clearTimer()
          }
        }, 1000)
      },

      clearTimer() {
        if (this.timer) {
          clearInterval(this.timer)
          this.timer = null
        }
      },

      formatTime(seconds) {
        const mins = Math.floor(seconds / 60)
        const secs = seconds % 60
        return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`
      },

      resendCode() {
        if (this.resending) return
        
        this.resending = true
        this.checkMobileAndSendCode()
        
        setTimeout(() => {
          this.resending = false
        }, 1000)
      },

      goBackToMobile() {
        // Clear code digits and reset to mobile input
        this.codeDigits = ['', '', '', '', '']
        this.level = 1
        this.clearTimer()
        this.canResend = false
        this.remainingTime = 180
        // Focus mobile input
        this.$nextTick(() => {
          if (this.$refs.mobile) {
            this.$refs.mobile.focus()
          }
        })
      },
      
      // استخراج کد از متن پیامک
      extractCodeFromText(text) {
        if (!text) return null
        
        // الگوهای مختلف برای استخراج کد:
        // 1. Code: 12345
        // 2. #12345
        // 3. فقط 5 رقم پشت سر هم
        
        // الگوی 1: Code: 12345
        const codePattern1 = /Code:\s*(\d{5})/i
        const match1 = text.match(codePattern1)
        if (match1) {
          return match1[1]
        }
        
        // الگوی 2: #12345
        const codePattern2 = /#(\d{5})/
        const match2 = text.match(codePattern2)
        if (match2) {
          return match2[1]
        }
        
        // الگوی 3: فقط 5 رقم پشت سر هم (اگر در متن پیامک باشه)
        const codePattern3 = /\b(\d{5})\b/
        const match3 = text.match(codePattern3)
        if (match3) {
          return match3[1]
        }
        
        return null
      },
      
      // چک کردن clipboard برای کد تایید
      async checkClipboardForCode() {
        // فقط در صفحه کد تایید چک کن
        if (this.level !== 2) return
        
        // اگر قبلاً کد کامل شده، چک نکن
        if (this.canProceedCode) return
        
        try {
          // خواندن clipboard
          const text = await navigator.clipboard.readText()
          
          if (text) {
            const code = this.extractCodeFromText(text)
            
            if (code && code.length === 5) {
              // اگر کد پیدا شد، وارد کن
              const digits = code.split('')
              // Fill from left to right (index 4 to 0)
              digits.forEach((digit, i) => {
                const targetIndex = 4 - i
                if (targetIndex >= 0 && targetIndex < 5) {
                  this.codeDigits[targetIndex] = digit
                }
              })
              
              // بعد از وارد کردن کد، به صورت خودکار ورود کن
              this.$nextTick(() => {
                if (this.canProceedCode) {
                  setTimeout(() => {
                    this.verifyCodeAndLogin()
                  }, 500)
                }
              })
            }
          }
        } catch (error) {
          // اگر دسترسی به clipboard نداریم، خطا رو نادیده بگیر
          // (مثلاً در مرورگرهای قدیمی یا بدون permission)
          console.log('Clipboard access not available:', error)
        }
      },
      
      // تنظیم listener برای clipboard
      setupClipboardListener() {
        // اضافه کردن listener برای paste event
        document.addEventListener('paste', this.handlePasteEvent)
      },
      
      // مدیریت paste event
      handlePasteEvent(event) {
        // فقط در صفحه کد تایید
        if (this.level !== 2) return
        
        const pastedText = event.clipboardData?.getData('text')
        
        if (pastedText) {
          const code = this.extractCodeFromText(pastedText)
          
          if (code && code.length === 5) {
            // اگر کد پیدا شد، وارد کن
            const digits = code.split('')
            // Fill from left to right (index 4 to 0)
            digits.forEach((digit, i) => {
              const targetIndex = 4 - i
              if (targetIndex >= 0 && targetIndex < 5) {
                this.codeDigits[targetIndex] = digit
              }
            })
            
            // بعد از وارد کردن کد، به صورت خودکار ورود کن
            this.$nextTick(() => {
              if (this.canProceedCode) {
                setTimeout(() => {
                  this.verifyCodeAndLogin()
                }, 500)
              }
            })
          }
        }
      },
    },
  }
</script>
<style scoped>
  .login-page {
    min-height: 100dvh;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    background: linear-gradient(135deg, #1c39bb 0%, #2563eb 100%);
    overflow: hidden;
    position: relative;
  }
  
  .login-page::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, rgba(28, 57, 187, 0.9) 0%, rgba(37, 99, 235, 0.9) 100%);
    backdrop-filter: blur(10px);
  }
  
  .login-layout {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: row;
    position: relative;
    z-index: 1;
  }

  /* Panels */
  .form-panel {
    width: 50%;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
    position: relative;
  }

  .form-panel .code-step-wrapper {
    padding-top: 64px;
  }
  .visual-panel {
    width: 50%;
    height: 100vh;
    background: #e9eef6;
    position: relative;
    overflow: hidden;
  }

  /* Card */
  .login-card-outer {
    position: relative;
    width: 100%;
    max-width: 460px;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(20px);
    border-radius: 24px;
    padding: 32px 24px 36px 24px;
    box-shadow: 
      0 20px 40px rgba(0, 0, 0, 0.1),
      0 8px 16px rgba(0, 0, 0, 0.05),
      inset 0 1px 0 rgba(255, 255, 255, 0.6);
    border: 1px solid rgba(255, 255, 255, 0.2);
    transform: translateY(0);
    transition: all 0.3s ease;
  }
  
  .login-card-outer:hover {
    transform: translateY(-2px);
    box-shadow: 
      0 25px 50px rgba(0, 0, 0, 0.15),
      0 10px 20px rgba(0, 0, 0, 0.08),
      inset 0 1px 0 rgba(255, 255, 255, 0.6);
  }
  
  .logo-wrap { 
    display: grid; 
    place-items: center; 
    margin-bottom: 40px;
    opacity: 0;
    animation: fadeInUp 0.6s ease forwards;
  }
  
  .logo { 
    max-width: 90px; 
    height: auto;
    filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1));
    border-radius: 10px;
  }
  
  .form-grid > * + * { margin-top: 16px; }
  .form-grid > * {
    opacity: 0;
    animation: fadeInUp 0.6s ease forwards;
  }
  .form-grid > *:nth-child(1) { animation-delay: 0.1s; }
  .form-grid > *:nth-child(2) { animation-delay: 0.2s; }
  .form-grid > *:nth-child(3) { animation-delay: 0.3s; }
  
  .actions { 
    margin-top: 24px;
    opacity: 0;
    animation: fadeInUp 0.6s ease forwards 0.4s;
  }

  /* Input styles */
  .input-group {
    position: relative;
    display: flex;
    align-items: center;
    background: rgba(248, 250, 252, 0.9);
    border: 2px solid rgba(226, 232, 240, 0.8);
    border-radius: 10px;
    min-height: 56px;
    padding: 0 16px 0 16px;
    transition: all 0.2s ease;
  }
  
  .input-group:focus-within {
    border-color: #1c39bb;
    box-shadow: 0 0 0 4px rgba(28, 57, 187, 0.12), 0 4px 12px rgba(28, 57, 187, 0.18);
    background: rgba(255, 255, 255, 0.95);
  }
  
  .input-group::before {
    content: attr(data-label);
    position: absolute;
    top: -10px;
    right: 12px;
    background: #fff;
    padding: 0 6px;
    border-radius: 6px;
    font-size: 12px;
    color: #475569;
    opacity: 0.9;
  }
  
  .input-icon {
    position: absolute;
    left: 12px;
    width: 22px;
    height: 22px;
    opacity: 0.8;
  }
  
  .input {
    width: 100%;
    height: 44px;
    border: none;
    outline: none;
    background: transparent;
    font-size: 15px;
    color: #111827;
  }

  /* Code Input Section */
  .code-input-section {
    width: 100%;
    position: relative;
  }

  .code-step-wrapper {
    position: relative;
    width: 100%;
  }

  .back-button-circle {
    position: absolute;
    top: -135px;
    left: -5px;
    width: 44px;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, rgba(243, 244, 246, 0.95) 0%, rgba(229, 231, 235, 0.95) 100%);
    border: 1px solid rgba(209, 213, 219, 0.6);
    border-radius: 50%;
    color: #ffffff;
    cursor: pointer;
    transition: all 0.2s ease;
    z-index: 10;
    box-shadow: 
      0 2px 8px rgba(0, 0, 0, 0.08),
      0 1px 3px rgba(0, 0, 0, 0.05),
      inset 0 1px 0 rgba(255, 255, 255, 0.4);
  }

  .back-button-circle:hover {
    background: linear-gradient(135deg, rgba(229, 231, 235, 0.95) 0%, rgba(209, 213, 219, 0.95) 100%);
    border-color: rgba(156, 163, 175, 0.8);
    box-shadow: 
      0 4px 12px rgba(0, 0, 0, 0.12),
      0 2px 4px rgba(0, 0, 0, 0.08),
      inset 0 1px 0 rgba(255, 255, 255, 0.5);
    transform: translateY(-1px);
  }

  .back-button-circle:active {
    transform: translateY(0);
    box-shadow: 
      0 1px 4px rgba(0, 0, 0, 0.1),
      inset 0 1px 2px rgba(0, 0, 0, 0.1);
  }

  .back-button-circle svg {
    width: 18px;
    height: 18px;
    stroke: #475569;
  }

  .back-button-circle:hover svg {
    stroke: #1c39bb;
  }

  .code-label {
    font-size: 14px;
    color: #475569;
    margin-bottom: 16px;
    text-align: center;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    flex-wrap: wrap;
  }

  .mobile-number-display {
    color: #1c39bb;
    font-weight: 600;
    font-size: 15px;
  }

  .code-inputs {
    display: flex;
    gap: 12px;
    justify-content: center;
    margin-bottom: 20px;
  }

  .code-input {
    width: 56px;
    height: 64px;
    border: 2px solid rgba(226, 232, 240, 0.8);
    border-radius: 12px;
    background: rgba(248, 250, 252, 0.9);
    text-align: center;
    font-size: 24px;
    font-weight: bold;
    color: #111827;
    transition: all 0.2s ease;
    outline: none;
  }

  .code-input:focus {
    border-color: #1c39bb;
    background: rgba(255, 255, 255, 0.95);
    box-shadow: 0 0 0 4px rgba(28, 57, 187, 0.12), 0 4px 12px rgba(28, 57, 187, 0.18);
    transform: scale(1.05);
  }

  .resend-section {
    text-align: center;
    margin-top: 16px;
  }

  .resend-btn {
    background: transparent;
    border: none;
    color: #1c39bb;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    padding: 8px 16px;
    border-radius: 8px;
    transition: all 0.2s ease;
  }

  .resend-btn:hover:not(:disabled) {
    background: rgba(28, 57, 187, 0.1);
  }

  .resend-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .resend-timer {
    font-size: 14px;
    color: #64748b;
    font-weight: 500;
  }

  .btn {
    width: 100%;
    height: 56px;
    border: 0;
    border-radius: 10px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    overflow: hidden;
  }
  
  .btn::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    transition: left 0.5s;
  }
  
  .btn:hover::before {
    left: 100%;
  }
  
  .btn:disabled { 
    opacity: 0.6; 
    cursor: not-allowed;
    transform: none;
  }
  
  .btn:not(:disabled):hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(28, 57, 187, 0.4);
  }
  
  .primary { 
    color: #ffffff; 
    background: linear-gradient(135deg, #1c39bb 0%, #2563eb 100%);
    box-shadow: 0 4px 15px rgba(28, 57, 187, 0.3);
  }

  /* Carousel slides */
  .slides { position: relative; width: 100%; height: 100%; }
  .slide { 
    width: 100%; 
    height: 100%; 
    min-height: 100dvh; 
    background-size: cover; 
    background-position: center;
    position: relative;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    transition: opacity 1s ease-in-out;
  }
  .slide.active { opacity: 1; }
  
  .slide::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, rgba(28, 57, 187, 0.3) 0%, rgba(1, 1, 36, 0.7) 100%);
  }
  
  .slide.placeholder { 
    background: linear-gradient(135deg, #1c39bb 0%, #2563eb 100%);
  }
  
  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .login-page { 
    min-height: 100vh; 
    width: 100%; 
    overflow: hidden; 
  }

  /* Responsive: hide slider on mobile */
  @media (max-width: 768px) {
    .login-layout { 
      height: auto; 
      min-height: 100vh; 
      flex-direction: column; 
    }
    .form-panel { 
      margin-top: 100px;
      width: 100%; 
      height: auto; 
      padding: 16px; 
    }
    .form-panel .code-step-wrapper {
      padding-top: 64px;
    }
    .visual-panel { 
      display: none !important; 
    }
    .code-input {
      width: 48px;
      height: 56px;
      font-size: 20px;
    }
    .code-inputs {
      gap: 8px;
    }
    .back-button-circle {
      top: -64px;
      left: 0;
    }
  }
</style>
